<template>
  <div class="pb-[10]">
    <dg-head width="100%"></dg-head>
    <div class="max-w-[1200] w-[100%] mt-[16] pb-[100] rounded-[4] mb-[20] px-[170] mx-[auto] shadow bg-[#fff] content_box">
      <template v-for="item in protocolList">
        <div class="text-center">
          <p class="t-[18] leading-[80] border-b-[1] border-[#ebeef5] border-solid">{{ item.title }}</p>
        </div>
        <div class="mt-[20]">
          <div class="" v-html="item.content">
          </div>
        </div>
      </template>
    </div>
    <dg-copyright copyrightWidth="w-[100%] max-w-[1024]"></dg-copyright>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";

export default {
  mixins: [mixin],
  data() {
    return {
      "content": "",
      title: "",
      protocolList: []
    }
  },

  methods: {
    /**
     * @author 伟健 / 张
     * @name 获取协议
     */
    getUserProtocol() {
      ajax.post({
        url: "/customer/auth/getUserProtocol",
        data: { code: this.$route.query.code || 0 },
        success: (res) => {
          if (res) {
            this.protocolList = res
          }
        },
        
      });
    },

  },
  created() {
    this.getUserProtocol();
  }
}
</script>

<style scoped lang="less">
// @import '~@/assets/css/var.less';

.shadow {
  box-shadow: 0 2px 10px 0 rgba(45, 72, 97, .1);
}
@media screen and (max-width: 736px) { 
  .content_box {
    padding: 30px 24px !important;
  }
}


</style>

<style lang="less">
@media screen and (max-width: 736px) {
  #app-wrap,
  #app {
    min-width: auto;
    /* width: 100vw; */
  }
}
</style>
